import { Pressable, View } from 'react-native';
import { FlattenInterpolation, ThemeProps } from 'styled-components';
import styled, { DefaultTheme, css } from 'styled-components/native';

import { CheckboxSize, CheckboxStyledProps } from './Checkbox.types';

const sizeStylesMap: Record<CheckboxSize, FlattenInterpolation<ThemeProps<DefaultTheme>>> = {
    s: css`
        height: 20px;
        width: 20px;
        border-radius: 6px;
    `,
    l: css`
        height: 24px;
        width: 24px;
        border-radius: 8px;
    `,
};

export const Container = styled(Pressable)<CheckboxStyledProps>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ size }) => sizeStylesMap[size]};
`;

export const Border = styled(View)<Pick<CheckboxStyledProps, 'size'>>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-width: 2px;
    border-style: solid;

    ${({ size }) => sizeStylesMap[size]};
`;

export const Background = styled(View)<Pick<CheckboxStyledProps, 'size'>>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.border.interactive};

    ${({ size }) => sizeStylesMap[size]};
`;
